import { SvgIconProps } from '@traba/types'

export function Paste({ size, color, strokeWidth, ...props }: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6665 3H11.6665C12.587 3 13.3332 3.74619 13.3332 4.66667V12.8333C13.3332 13.7538 12.587 14.5 11.6665 14.5H4.33317C3.4127 14.5 2.6665 13.7538 2.6665 12.8333V4.66667C2.6665 3.74619 3.4127 3 4.33317 3H5.33317"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M5 2.92668C5 2.48779 5.26721 2.09312 5.6747 1.93012L7.50481 1.19807C7.82269 1.07092 8.17731 1.07092 8.49519 1.19808L10.3253 1.93012C10.7328 2.09312 11 2.48779 11 2.92668V2.92668C11 3.51946 10.5195 4 9.92668 4H6.07332C5.48054 4 5 3.51946 5 2.92668V2.92668Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M6.6665 8.93333L7.6362 10L9.33317 8"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
